import React from "react";
export var ProgressStepper = function (_a) {
    var currentStep = _a.currentStep, steps = _a.steps;
    return (React.createElement("div", { className: "progress-stepper" }, steps.map(function (step, index) {
        var isActive = currentStep >= step.id;
        var isCurrent = currentStep === step.id;
        return (React.createElement(React.Fragment, { key: step.id },
            React.createElement("div", { className: "step ".concat(isActive ? 'active' : '', " ").concat(isCurrent ? 'current' : '') },
                React.createElement("div", { className: "step-number" }, step.id),
                React.createElement("div", { className: "step-label" }, step.label)),
            index < steps.length - 1 && (React.createElement("div", { className: "step-connector ".concat(currentStep > step.id ? 'active' : '') }))));
    })));
};
export var ENROLL_STEPS = [
    { id: 1, label: "Escaneo facial" },
    { id: 2, label: "Escaneo documento" },
    { id: 3, label: "Procesamiento" }
];
export var VERIFICATION_STEPS = [
    { id: 1, label: "Escaneo facial" },
    { id: 2, label: "Procesamiento" }
];
